"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefDialog = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
const Base_1 = require("../../../model/Base");
const List_1 = require("../../List/List");
const PropertyPageControls_1 = require("../PropertyPageControls");
const ExternalInput_1 = require("./ExternalInput");
let refDialogMarkup = require("../../../templates/externalInputs/RefDialog.tmpl.html");
/**
* FT-Ref-Dialog
*/
class RefDialog extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.m_addedItems = [];
        this.m_removedItems = [];
        this.windowContentCssClass = "eiRefDialog";
        this.needServerConfig = true;
        this.windowWidth = 800;
        this.windowHeight = 600;
        this.windowActions = ["Maximize", "Close"];
        if (this.input.field.treatAsSingleValue)
            this.multiValue = false;
    }
    destroyWidgets() {
        if ($("#" + this.idData.splitter).data("kendoSplitter"))
            $("#" + this.idData.splitter).data("kendoSplitter").destroy();
        if ($("#" + this.idData.fromList).synList)
            $("#" + this.idData.fromList).synList("destroy");
        if ($("#" + this.idData.toList).synList)
            $("#" + this.idData.toList).synList("destroy");
    }
    getUpdatedInstance() {
        let that = this;
        let transferFields = that.config.tables[that.config.tableName].transferFields;
        let selection = $("#" + that.idData.toList).synList("getItems");
        let ceforeigntableext4 = that.methodName === "ceforeigntableext.4";
        if (ceforeigntableext4) {
            let arr = $.map(selection, (elem) => {
                return elem[that.config.tableName + "_id"].toString();
            });
            let arr2 = $.map(selection, (elem) => {
                return elem[that.input.field.fieldName.replace(/\./g, "_")].toString();
            });
            let value = arr, value2 = arr2;
            if (that.mode === Base_1.PropertyPageMode.Search) {
                value = arr.join("||");
                value2 = "";
            }
            else if (!that.multiValue) {
                value = arr.join(";");
                value2 = arr2.join(";");
            }
            that.currentInstance.items[that.input.field.fieldName].value = value2;
            that.currentInstance.items[that.input.field.presentedField].value = value;
        }
        else {
            let arr = $.map(selection, (elem) => {
                let tmp = "";
                $.each(transferFields, function (idx, field) {
                    if (idx > 0)
                        tmp += " " + that.config.valueSeparator + " ";
                    let v = elem[field.replace(/\./g, "_")];
                    tmp += (v ? v.toString() : "");
                });
                if (that.config.trailingUniqueId)
                    tmp = tmp + " &id=" + elem.id;
                else
                    tmp = elem.id + ": " + tmp;
                return tmp;
            });
            let value = arr;
            if (that.mode === Base_1.PropertyPageMode.Search)
                value = arr.join("||");
            else if (!that.multiValue)
                value = arr.join(";");
            that.currentInstance.items[that.input.field.fieldName].value = value;
        }
        return Promise.resolve(that.currentInstance);
    }
    buildMaskForTable(tableName) {
        let that = this;
        let tableConfig = that.config.tables[tableName];
        let needsMandatory = tableConfig.needsMandatoryField;
    }
    mapEntries(results) {
        if (!results)
            return [];
        let that = this;
        let uniqueField = that.config.tables[that.config.tableName].uniqueField;
        let dataItems = List_1.instancesToListDataItems(results);
        for (let i = 0; i < results.length; ++i)
            dataItems[i].id = results[i].items[uniqueField].value.toString();
        return dataItems;
    }
    getSearchText(addWildcards) {
        let searchConstraints = [];
        $("#" + this.idData.searchFields).find(".searchFieldBox").each((_idx, elem) => {
            let textbox = $(elem);
            let fieldName = textbox.attr("data-fieldname");
            let value = textbox.val();
            if (value)
                searchConstraints.push(fieldName + "=" + value);
            else {
                if (addWildcards) {
                    let v = "*";
                    if (value)
                        v = value;
                    searchConstraints.push(fieldName + "=" + v);
                }
            }
        });
        return searchConstraints.join(";");
    }
    getValuesSupplied() {
        let valuesSupplied = false;
        $("#" + this.idData.searchFields).find(".searchFieldBox").each((_idx, elem) => {
            let textbox = $(elem);
            let value = textbox.val();
            if (value) {
                valuesSupplied = true;
                return false;
            }
        });
        return valuesSupplied;
    }
    searchRefTables(that) {
        const valuesSupplied = that.getValuesSupplied();
        if (that.config.tables[that.config.tableName].needsMandatoryField && !valuesSupplied)
            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("hypdlgmandatoryfield", "Please enter a filter"));
        else {
            Utilities_1.synUtil.beginAjaxProgress("#" + that.idData.searchButton);
            $("#" + that.idData.fromList).synList("refreshAsync").
                then(() => {
                Utilities_1.synUtil.endAjaxProgress("#" + that.idData.searchButton);
            });
        }
    }
    initWindowContents() {
        let that = this;
        let hyperlinkFieldResultList;
        let hyperlinkFieldSelectedList;
        let toListName;
        that.windowData.windowDiv.css("overflow", "hidden");
        let rawConf = this.serverConfig;
        that.config = {
            valueSeparator: "|",
            tables: {}
        };
        that.config.trailingUniqueId = ("Y" === rawConf.trailinguniqueid);
        that.config.valueSeparator = rawConf.valueseparator;
        if (rawConf.hypdlgvalueseparator)
            that.config.valueSeparator = rawConf.hypdlgvalueseparator;
        let tableConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tablessearchfield, "|");
        $.each(tableConfigs, function (idx, tableConfig) {
            let tmp = tableConfig.split(":");
            let searchFields = Utilities_1.synUtil.splitWithoutEmptyEntries(tmp[1], ";");
            that.config.tables[tmp[0]] = {
                searchFields,
                needsMandatoryField: false
            };
            that.config.tableName = tmp[0];
        });
        if (rawConf.tablesmandatoryfield) {
            let mandatoryConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tablesmandatoryfield, "|");
            $.each(mandatoryConfigs, function (idx, mandConf) {
                let tmp = mandConf.split(":");
                if (that.config.tables[tmp[0]])
                    that.config.tables[tmp[0]].needsMandatoryField = (tmp[1] === "Y");
            });
        }
        if (rawConf.tablesuniquefield) {
            let uniqueConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tablesuniquefield, "|");
            $.each(uniqueConfigs, function (idx, unqConf) {
                let tmp = unqConf.split(":");
                if (that.config.tables[tmp[0]])
                    that.config.tables[tmp[0]].uniqueField = tmp[1];
            });
        }
        if (rawConf.tablestransferfield) {
            let transferConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tablestransferfield, "|");
            $.each(transferConfigs, function (idx, trConf) {
                let tmp = trConf.split(":");
                let transferFields = Utilities_1.synUtil.splitWithoutEmptyEntries(tmp[1], ";");
                if (that.config.tables[tmp[0]])
                    that.config.tables[tmp[0]].transferFields = transferFields;
            });
        }
        if (rawConf.tableshyperlinkfield) {
            let hyperlinkConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tableshyperlinkfield, "|");
            $.each(hyperlinkConfigs, function (idx, hypConf) {
                let tmp = hypConf.split(":");
                if (that.config.tables[tmp[0]])
                    that.config.tables[tmp[0]].hyperlinkField = tmp[1];
            });
        }
        if (rawConf.tablesdefaultfilterfield) {
            let defaultFilterConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tablesdefaultfilterfield, ";");
            let defObj = {};
            $.each(defaultFilterConfigs, function (idx, defConf) {
                let tmp = defConf.split("=");
                defObj[tmp[0]] = tmp[1];
            });
            if (that.config.tables[that.config.tableName])
                that.config.tables[that.config.tableName].defaultFilters = defObj;
        }
        if (rawConf.tablesdefaultsearchfilterfield) {
            let defaultSearchFilterConfigs = Utilities_1.synUtil.splitWithoutEmptyEntries(rawConf.tablesdefaultsearchfilterfield, ";");
            let defObj = {};
            $.each(defaultSearchFilterConfigs, function (idx, defConf) {
                let tmp = defConf.split("=");
                defObj[tmp[0]] = tmp[1];
            });
            if (that.config.tables[that.config.tableName])
                that.config.tables[that.config.tableName].defaultSearchFilters = defObj;
        }
        that.config.fieldTitles = {};
        if (rawConf.field_captions) {
            let tmp = rawConf.field_captions.split("|");
            $.each(tmp, function (idx, elem) {
                let s = elem.split(":");
                that.config.fieldTitles[s[0]] = s[1];
            });
        }
        let parseListLayout = (layout) => {
            let arr = [];
            if (layout) {
                let tmp = layout.split("|");
                $.each(tmp, function (idx, elem) {
                    let s = elem.split(";");
                    let fieldItem = {
                        fieldName: s[0],
                        fieldType: parseInt(s[1], 10),
                        fieldConstraint: parseInt(s[2], 10),
                        seqNum: parseInt(s[3], 10)
                    };
                    if (that.config.fieldTitles[s[0]])
                        fieldItem["fieldTitle"] = that.config.fieldTitles[s[0]];
                    arr.push(fieldItem);
                });
            }
            return arr;
        };
        that.config.resultListLayoutFields = parseListLayout(rawConf.layoutfields_resultlist);
        that.config.selectedListLayoutFields = parseListLayout(rawConf.layoutfields_selectedlist);
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            resizable: true,
            minWidth: that.windowMinWidth == undefined ? that.windowWidth : that.windowMinWidth,
            minHeight: that.windowMinHeight == undefined ? that.windowHeight : that.windowMinHeight
        });
        let idData = {
            synUtil: Utilities_1.synUtil,
            readOnly: that.input.readonlyForExtInput
        };
        $.each([
            "splitter",
            "tablesLabel",
            "searchButton",
            "searchFields",
            "fromList",
            "fromListDiv",
            "upButton",
            "downButton",
            "toList",
            "toListDiv",
            "buttonDiv"
        ], function (idx, id) {
            idData[id] = id + "_" + that.windowData.guid;
        });
        that.idData = idData;
        let template = kendo.template(refDialogMarkup);
        let result = template(idData);
        that.widgetContainer.html(result);
        dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            resizable: true,
            minWidth: that.windowMinWidth == undefined ? that.windowWidth : that.windowMinWidth,
            minHeight: that.windowMinHeight == undefined ? that.windowHeight : that.windowMinHeight
        });
        if (that.input.readonlyForExtInput) {
            $("#" + idData.splitter).children(".toListDiv").css("height", "100%");
            $("#" + idData.splitter).find("#" + idData.toList).css("height", "100%");
        }
        else {
            let resizeGrid = (gridElement) => {
                let dataArea = gridElement.find(".k-grid-content");
                let newHeight = gridElement.parent().innerHeight() - 2;
                if (gridElement.attr("id") === $("#" + that.idData.toList).attr("id"))
                    newHeight -= $("#" + that.idData.buttonDiv).outerHeight(true);
                let diff = gridElement.innerHeight() - dataArea.innerHeight();
                gridElement.height(newHeight);
                dataArea.height(newHeight - diff);
            };
            $("#" + idData.splitter).kendoSplitter({
                orientation: "vertical",
                panes: [
                    { size: "36px", scrollable: false, resizable: false },
                    { size: "120px", min: "20px", scrollable: true, resizable: true, collapsible: true },
                    { size: "33%", min: "20px", scrollable: true, resizable: true },
                    { size: "33%", min: "20px", scrollable: false, resizable: true },
                ],
                resize() {
                    resizeGrid($("#" + idData.fromList));
                    resizeGrid($("#" + idData.toList));
                }
            });
            $("#" + idData.splitter).children(".k-splitbar-vertical").first().css("display", "none");
            let $viewButton = $("<button type='button' class='btn btn-primary btn-xs'><i class='fa fa-search'></i></button>")
                .css({
                "margin-right": "30px",
                "min-width": "inherit"
            })
                .on("click", function (e) {
                e.preventDefault();
                let splitter = $("#" + idData.splitter).data("kendoSplitter");
                if ($(this).hasClass("btn-default")) {
                    $(this).removeClass("btn-default").addClass("btn-primary");
                    splitter.expand("#" + idData.searchFields);
                }
                else {
                    $(this).removeClass("btn-primary").addClass("btn-default");
                    splitter.collapse("#" + idData.searchFields);
                }
            })
                .prependTo(that.windowData.windowDiv.data("kendoWindow").wrapper.find(".k-window-actions"));
            let firstTable;
            for (let prop in that.config.tables)
                if (that.config.tables.hasOwnProperty(prop)) {
                    if (firstTable == undefined)
                        firstTable = prop;
                    $("#" + idData.tablesLabel).append(prop);
                }
            let tableConfig = that.config.tables[firstTable];
            $.each(tableConfig.searchFields, function (idx, field) {
                let title = that.config.fieldTitles[field] || field;
                let id = field.replace(/\./, "_") + "_" + that.windowData.guid;
                let div = $("<div class='fieldContainer'></div>").appendTo($("#" + idData.searchFields));
                if (idx === 0)
                    div.css("margin-top", "1px");
                let defaultMap = (that.mode === Base_1.PropertyPageMode.Search ?
                    tableConfig.defaultSearchFilters : tableConfig.defaultFilters);
                let defValue = "";
                if (defaultMap && defaultMap[field]) {
                    let instanceField = that.currentInstance.items[defaultMap[field]];
                    if (instanceField)
                        defValue = PropertyPageControls_1.FieldControl.convertCore(instanceField.value, Base_1.FieldType[instanceField.type], instanceField.multiValue || false, false, that.mode, undefined);
                }
                div.append("<label class='searchFieldLabel dlgLabel' for='" + id + "'>" + title + "</label>");
                let input = $("<input class='searchFieldBox k-textbox' id='" + id + "' data-fieldname='" + field
                    + "' value='" + defValue + "'></input>")
                    .keypress(function (e) {
                    if (e.which === 13)
                        $("#" + idData.searchButton).trigger("click");
                })
                    .appendTo(div);
            });
            let maxLabelWidth = 0;
            $("#" + idData.searchFields).find(".searchFieldLabel").each(function (idx, elem) {
                maxLabelWidth = Math.max(maxLabelWidth, $(elem).outerWidth(true));
            });
            $("#" + idData.searchFields).find(".searchFieldLabel").each(function (idx, elem) {
                $(elem).css({ "display": "inline-block", "width": maxLabelWidth + "px" });
            });
            $("#" + idData.searchFields).find(".searchFieldBox").each(function (idx, elem) {
                $(elem).css("width", ($("#" + idData.searchFields).innerWidth() - (maxLabelWidth + 30)) + "px");
            });
            let fromListName = "hyperlinkexterninputdialog\\resultlistctrl\\" + firstTable;
            toListName = "hyperlinkexterninputdialog\\selectedlistctrl\\" + firstTable;
            if (tableConfig.hyperlinkField) {
                let fn = (elem) => { return elem.fieldName === tableConfig.hyperlinkField; };
                if ($.grep(that.config.resultListLayoutFields, fn).length)
                    hyperlinkFieldResultList = tableConfig.hyperlinkField;
                if ($.grep(that.config.selectedListLayoutFields, fn).length)
                    hyperlinkFieldSelectedList = tableConfig.hyperlinkField;
            }
            $("#" + idData.fromList)
                .synList({
                columnOptions: {
                    layoutName: fromListName,
                    windowNameDependent: true,
                    layoutTemplate: that.config.resultListLayoutFields,
                    hyperlinkFieldName: hyperlinkFieldResultList
                },
                selectionMode: (that.multiValue ? "Multiple" : "Single"),
                showIcons: false,
                dataItemGenerator: () => {
                    return new Promise((resolve) => {
                        const searchText = that.getSearchText(true);
                        that.serverAction({
                            action: "searchreftables",
                            customData: { searchText },
                            callBack: (data) => {
                                resolve(that.mapEntries(data.readObjects));
                                if (data.additionalInformation.ERRORTEXT)
                                    Utilities_1.synUtil.Notifications.error(data.additionalInformation.ERRORTEXT);
                            },
                            overrideInstance: undefined
                        });
                    });
                },
                autoBind: false
            }).then(() => {
                $("#" + idData.searchButton).on("click", function () {
                    that.searchRefTables(that);
                });
                $(".searchFieldBox").keydown(function (e) {
                    if (e.which === 188)
                        e.preventDefault();
                });
                $("#" + idData.downButton)
                    .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    that.beginAjax();
                    yield that.addSelectedEntriesAsync($("#" + idData.fromList), $("#" + idData.toList));
                    that.endAjax();
                }));
                $("#" + idData.upButton)
                    .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    that.beginAjax();
                    yield that.removeSelectedEntriesAsync($("#" + idData.toList));
                    that.endAjax();
                }));
            });
        }
        $("#" + idData.toList)
            .synList({
            columnOptions: {
                layoutName: toListName,
                windowNameDependent: true,
                layoutTemplate: that.config.selectedListLayoutFields,
                hyperlinkFieldName: hyperlinkFieldSelectedList
            },
            selectionMode: (that.multiValue ? "Multiple" : "Single"),
            showIcons: false,
            dataItemGenerator: () => {
                return new Promise((resolve) => {
                    let val = that.currentInstance.items[that.input.field.fieldName].value;
                    let query;
                    if (that.mode === Base_1.PropertyPageMode.Search)
                        // replace || with ;
                        query = that.input.convert(val, true).replace(/\|\|/g, ";");
                    else {
                        if (that.multiValue)
                            query = $.map(val, function (v) { return that.input.convert(v, true); }).join(";");
                        else
                            query = that.input.convert(val, true);
                    }
                    if (query) {
                        const searchConstraints = that.getSearchText(false);
                        if (searchConstraints)
                            query += ";" + searchConstraints;
                        let overrideInstance = that.currentInstance;
                        if (that.mode === Base_1.PropertyPageMode.Search) {
                            let oldVal = overrideInstance.items[that.input.field.fieldName].valueToString();
                            if (oldVal) {
                                oldVal = oldVal.replace(/\|\|/g, ";");
                                overrideInstance.items[that.input.field.fieldName].valueAsString = oldVal;
                            }
                        }
                        that.serverAction({
                            action: "getselectedentries",
                            customData: { searchText: query },
                            overrideInstance,
                            callBack: (data) => {
                                // Values in instance
                                //    PLUS values added by user in this dialog
                                //    MINUS values removed by the user in this dialog
                                let serverItems = that.mapEntries(data.readObjects);
                                if (that.multiValue)
                                    serverItems = serverItems.concat(that.m_addedItems);
                                else if (that.m_addedItems.length)
                                    serverItems = that.m_addedItems;
                                let mapRemoved = {};
                                that.m_removedItems
                                    .forEach(item => { mapRemoved[item.id] = true; });
                                resolve(serverItems.filter(item => !mapRemoved[item.id]));
                            }
                        });
                    }
                    else
                        resolve(that.m_addedItems);
                });
            }
        });
        return Promise.resolve();
    }
    addSelectedEntriesAsync($fromList, $toList) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            const selectedIds = $fromList.synList("getSelectedIds");
            if (selectedIds.length) {
                const toListItems = $toList.synList("getItems");
                let mapSelected = {};
                let mapAdded = {};
                let mapExisting = {};
                selectedIds.forEach((id) => { mapSelected[id] = true; });
                that.m_addedItems
                    .map(item => item.id)
                    .forEach((id) => { mapAdded[id] = true; });
                toListItems
                    .map(item => item.id)
                    .forEach((id) => { mapExisting[id] = true; });
                const itemsToAdd = $fromList.synList("getItems")
                    .filter(item => mapSelected[item.id] && !mapAdded[item.id] && !mapExisting[item.id]);
                if (that.multiValue)
                    that.m_addedItems = that.m_addedItems.concat(itemsToAdd);
                else
                    that.m_addedItems = itemsToAdd;
                yield $toList.synList("refreshAsync");
            }
        });
    }
    removeSelectedEntriesAsync($toList) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // If an entry is in this.m_addedItems, remove it from there
            // Else, if it's not already in this.m_removedItems, add it to this.m_removedItems
            const selectedIds = $toList.synList("getSelectedIds");
            if (selectedIds.length) {
                const toListItems = $toList.synList("getItems");
                let mapSelected = {};
                let mapAdded = {};
                let mapRemoved = {};
                selectedIds.forEach((id) => { mapSelected[id] = true; });
                this.m_addedItems
                    .map(item => item.id)
                    .forEach((id) => { mapAdded[id] = true; });
                this.m_removedItems
                    .map(item => item.id)
                    .forEach((id) => { mapRemoved[id] = true; });
                let mapToRemove = {};
                toListItems
                    .filter(item => mapSelected[item.id])
                    .forEach((item) => {
                    if (mapAdded[item.id])
                        mapToRemove[item.id] = true;
                    else if (!mapRemoved[item.id])
                        this.m_removedItems.push(item);
                });
                for (let i = this.m_addedItems.length - 1; i >= 0; --i) {
                    if (mapToRemove[this.m_addedItems.length[i]])
                        this.m_addedItems.splice(i, 1);
                }
                yield $toList.synList("refreshAsync");
            }
        });
    }
}
exports.RefDialog = RefDialog;
